module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_L2-66be9308082d93e6b75d40cc9044b1c0.webp";